import { arrayToObject } from '../utils/misc'
import { fetchJsonWithErrorHandling } from '../utils/fetch'

export default async function fetchStompunkter({ path, query = {}, body }) {
	if(query.srid === 4976){
		query.srid = 3006;
	}

	const response = await fetchJsonWithErrorHandling({
		path: "/api/" + path,
		query,
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(body)
	})
	return arrayToObject(response.features, 'id')
}



// WEBPACK FOOTER //
// ./src/dataSource/fetchStompunkter.js